import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/packagesSalesSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const PricingOption = () => {
  const dispatch = useDispatch();
  const pricingOptionsLoading = useSelector((state) => state.packagesSales.pricingOptionsLoading);
  const pricingOptions = useSelector((state) => state.packagesSales.filters.pricing_options);
  const selectedPricingOptions = useSelector(
    (state) => state.packagesSales.selectedFilters.pricing_options
  );

  return pricingOptionsLoading ? (
    <LoadingAnimation uiLoader />
  ) : (
    <MultiSelectDropdown
      placeholder="Sales Package"
      options={pricingOptions}
      selectedFilters={selectedPricingOptions}
      numberDisplayed={0}
      includeSelectAll
      height={324}
      enableOnly
      onSelectChange={(data) => dispatch(actionCreators.updatePricingOption(data))}
    />
  );
};

export default PricingOption;
